import { gql } from '@apollo/client';

export const GET_CONSENSUS_PICK_STATS = gql`
  query GetConsensusPickStats($timePeriod: String = "90_DAYS") {
    consensusPickStats(timePeriod: $timePeriod) {
      rows {
        trackType
        agreeRaces
        agreeWins
        agreeStrikePct
        m1Races
        m1Wins
        m1StrikePct
      }
    }
  }
`;
